export default __webpack_public_path__ + "static/media/TN_HOME.04636eea.png";